import { render } from "./ChoosePlanV14.vue?vue&type=template&id=764bf476"
import script from "./ChoosePlanV14.vue?vue&type=script&lang=ts"
export * from "./ChoosePlanV14.vue?vue&type=script&lang=ts"

import "./ChoosePlanV14.vue?vue&type=style&index=0&id=764bf476&lang=scss"
script.render = render

export default script